import {
  useCheckContacts,
  useFetchContacts,
  useSaveContacts,
} from "@src/details/detailApi";
import ContactInfoForm from "@src/details/ContactInfoForm";
import Overview from "@src/details/Overview";
import { NavLink, Route, Switch, useRouteMatch } from "react-router-dom";
import ErrorPage from "@src/ErrorPage";
import { RPFormattedMessage } from "@src/i18n";
import { ResponsiveSecondLevelNav } from "@src/common/Navigation";

const CompanyDetailsContent = () => {
  const contactInfo = useFetchContacts();
  const {
    mutate: saveContactInfo,
    isError: submitError,
    isLoading: loading,
    isSuccess: success,
  } = useSaveContacts();
  const { url } = useRouteMatch();

  switch (contactInfo.status) {
    case "idle":
    case "loading":
      return <div className="page-loading-indicator" />;
    case "error":
      return <ErrorPage />;
    case "success":
      return (
        <Switch>
          <Route exact path={`${url}`}>
            <Overview />
          </Route>
          <Route exact path={`${url}/contacts`}>
            <ContactInfoForm
              contactInfo={contactInfo.data}
              saveContactInfo={saveContactInfo}
              submitError={submitError}
              loading={loading}
              success={success}
            />
          </Route>
        </Switch>
      );
  }
};

const CompanyDetails = () => {
  const { url } = useRouteMatch();
  const contactsOk = useCheckContacts();

  return (
    <div className="row">
      <div className="col-12 col-lg-3">
        <ResponsiveSecondLevelNav>
          <li className="nav-item">
            <NavLink
              className="nav-link vastuu-green"
              id="detailMenuContactsLink"
              exact
              to={`${url}`}
            >
              <RPFormattedMessage id="overview" defaultMessage="Yhteenveto" />
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              className="nav-link vastuu-green"
              id="detailMenuContactsLink"
              exact
              to={`${url}/contacts`}
            >
              <div className="align-items-center">
                <RPFormattedMessage
                  id="contactInfo"
                  defaultMessage="Yhteystiedot"
                />
                {!contactsOk && (
                  <i
                    className="fa fa-exclamation-circle ml-4 align-self-center"
                    aria-hidden="true"
                  ></i>
                )}
              </div>
            </NavLink>
          </li>
        </ResponsiveSecondLevelNav>
      </div>
      <div className="col-12 col-lg-9 position-relative">
        <CompanyDetailsContent />
      </div>
    </div>
  );
};

export default CompanyDetails;
